import React from "react";
import { SHTypography } from "@components/design-systems";
import { ModelScreenerCellData } from "@models/model-screener/entities/modelScreenerData";
import { SHTextOverflowTooltip } from "@components/design-systems/sh-text-overflow-tooltip";

export const MSTableTextShortCell = React.memo(
  ({ cellData }: { cellData: ModelScreenerCellData }) => {
    return (
      <SHTextOverflowTooltip tooltipContent={cellData.value}>
        <SHTypography variant={"body2"} fontSize={13} lineHeight={1.2}>
          {cellData.value}
        </SHTypography>
      </SHTextOverflowTooltip>
    );
  },
);
